import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { CloseOutlined } from "@mui/icons-material";
import {
  Table,
  TableCell,
  TableRow,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
  Card,
  CardContent,
  Grid,
  Divider,
} from "@mui/material";
import { Download, CheckCircle, Cancel } from "@mui/icons-material";
import Service from "./partner/Service";
import moment from "moment";
import ServiceHistory from "./partner/ServiceHistory";

import RequestHistory from "./partner/RequestHistory";
import PastRequestHistory from "./partner/PastRequestHistory";
import axios from "axios";
import { deleteRequest, patchRequest, server } from "../config";
import { toast } from "react-toastify";
import ReferalPartners from "./partner/ReferalPartners";
import PartnerManger from "./manager/PartnerManger";
import ServiceHistoryManager from "./manager/ServiceHistory";
import PaymentHistory from "./manager/PaymentHistory";
import { generateManagerInvoice } from "./manager/InvoicePDF";

const MangerProfile = ({ manager, onClose }) => {
  const [value, setValue] = React.useState(0);
  const [openEdit, setOpenEdit] = useState(false);
  const [formData, setFormData] = useState({ ...manager });

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleEditOpen = () => setOpenEdit(true);
  const handleEditClose = () => setOpenEdit(false);

  const handleChangeInput = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleDeletePartner = async () => {   
    if (!window.confirm("Are you sure you want to delete this manager?")) {
      return;
    }
    try {
     const res= await patchRequest(`${server.uri}/users/${manager.userId}`, {
        isDeleted:true
      });
      if(res!==200){  
       toast.error("Failed to delete manager");
       return
      }
      toast.success("manager deleted successfully");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to delete manager");
    }
  }
  const handleDeletePartnerPermanent = async () => {   
    if (!window.confirm("Are you sure you want to delete this manager?")) {
      return;
    }
    try {
     const res= await deleteRequest(`${server.uri}/users/${manager.userId}/delete`);
      if(res!==204){  
       toast.error("Failed to delete manager");
       return
      }
      toast.success("manager deleted successfully");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to delete manager");
    }
  }
  const handleUpdate = async () => {
    try {
      console.log(formData);
      
      await patchRequest(`${server.uri}/users/${manager.userId}`, {
        name: formData.name,
        mobileNumber: formData.mobileNumber,
        city: formData.city,
        status: formData.status,
        servingPinCodes: formData.servingPinCodes,
        fullAddress: formData.fullAddress,
        paymentTransactionId: formData?.isPaymentDone=='verified' ? formData.paymentTransactionId || null : null,
        registrationPaidAt: formData?.isPaymentDone=='verified'
          ? (formData.registrationPaidAt ? new Date(formData.registrationPaidAt) : new Date())
          : null,
      });
      alert("manager updated successfully");
      setOpenEdit(false);
    } catch (err) {
      console.error(err);
      alert("Failed to update manager");
    }
  };

  // Generate Invoice Button Component
  const GenerateInvoiceButton = ({ userId, name }) => {
    const [invoiceLoading, setInvoiceLoading] = useState(false);

    const handleGenerateInvoice = async () => {
      setInvoiceLoading(true);
      try {
        await generateManagerInvoice(manager);
        toast.success("Invoice downloaded!");
      } catch (err) {
        console.error("Invoice generation error:", err);
        toast.error("Failed to generate invoice. Please try again.");
      } finally {
        setInvoiceLoading(false);
      }
    };

    return (
      <Box>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Download />}
          onClick={handleGenerateInvoice}
          disabled={invoiceLoading}
        >
          {invoiceLoading ? "Generating Invoice..." : "Generate & Download Invoice"}
        </Button>
      </Box>
    );
  };

  return (
    <>
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        {manager?.name} (Manger)
      </Typography>

      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "100px",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {/* <Tab label="Services" {...a11yProps(0)} /> */}
          <Tab label="Service History" {...a11yProps(0)} />
          <Tab label="Payment History" {...a11yProps(1)} />
          {/* <Tab label="Request History" {...a11yProps(3)} />
          <Tab label="Past Request History" {...a11yProps(4)} /> */}
          <Tab label="Referal Partners" {...a11yProps(2)} />
          <Tab label="Registration" {...a11yProps(3)} />
          <Tab label="Profile" {...a11yProps(4)} />
        </Tabs>
        <div onClick={onClose} className="cursor-pointer">
          <CloseOutlined />
        </div>
      </Box>

      {/* <CustomTabPanel value={value} index={0}>
        <Service partnerId={manager?.userId} />
      </CustomTabPanel> */}

      <CustomTabPanel value={value} index={0}>
        <ServiceHistoryManager servingPinCodes={manager?.servingPinCodes} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <PaymentHistory servingPinCodes={manager?.servingPinCodes} />
      </CustomTabPanel>
{/* 
      <CustomTabPanel value={value} index={3}>
        <RequestHistory partnerId={manager?.userId} />
      </CustomTabPanel> */}

      {/* <CustomTabPanel value={value} index={4}>
        <PastRequestHistory partnerId={manager?.userId} />
      </CustomTabPanel> */}
      <CustomTabPanel value={value} index={2}>
        <PartnerManger servingPinCodes={manager?.servingPinCodes} />
        </CustomTabPanel>

      {/* Registration Tab */}
      <CustomTabPanel value={value} index={3}>
        <Box sx={{ maxWidth: 900 }}>
          <Typography variant="h6" gutterBottom>
            Registration Details
          </Typography>

          {/* Payment Status Card */}
          <Card sx={{ mb: 3, bgcolor: manager?.registrationPaidAt ? "success.50" : "warning.50" }}>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {manager?.registrationPaidAt ? (
                  <CheckCircle sx={{ fontSize: 40, color: "success.main" }} />
                ) : (
                  <Cancel sx={{ fontSize: 40, color: "warning.main" }} />
                )}
                <Box>
                  <Typography variant="h6">
                    {manager?.registrationPaidAt ? "Payment Completed" : "Payment Pending"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Registration Fee: ₹{manager?.registrationFee?.toLocaleString("en-IN") || "15,000"}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Grid container spacing={3}>
            {/* Payment Info */}
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Payment Information
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Table size="small">
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", border: 0 }}>Transaction ID</TableCell>
                      <TableCell sx={{ border: 0 }}>{manager?.paymentTransactionId || "-"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", border: 0 }}>Payment Date</TableCell>
                      <TableCell sx={{ border: 0 }}>
                        {manager?.registrationPaidAt
                          ? moment(manager.registrationPaidAt).format("DD/MM/YYYY hh:mm A")
                          : "-"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", border: 0 }}>Valid Until</TableCell>
                      <TableCell sx={{ border: 0 }}>
                        {manager?.registrationExpiresAt
                          ? moment(manager.registrationExpiresAt).format("DD/MM/YYYY")
                          : "-"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", border: 0 }}>Terms Accepted</TableCell>
                      <TableCell sx={{ border: 0 }}>
                        {manager?.termsAcceptedAt
                          ? moment(manager.termsAcceptedAt).format("DD/MM/YYYY hh:mm A")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  </Table>
                </CardContent>
              </Card>
            </Grid>

            {/* KYC Info */}
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    KYC Documents
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Table size="small">
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", border: 0 }}>PAN Number</TableCell>
                      <TableCell sx={{ border: 0 }}>{manager?.panCardNumber || "-"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", border: 0 }}>Aadhaar Number</TableCell>
                      <TableCell sx={{ border: 0 }}>
                        {manager?.aadhaarCardNumber
                          ? `****-****-${manager.aadhaarCardNumber.slice(-4)}`
                          : "-"}
                      </TableCell>
                    </TableRow>
                  </Table>
                </CardContent>
              </Card>
            </Grid>

            {/* Document Images */}
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Uploaded Documents
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {/* PAN Card */}
                    {manager?.panCardUrl && (
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" gutterBottom>
                          PAN Card
                        </Typography>
                        <Box
                          component="img"
                          src={manager.panCardUrl}
                          alt="PAN Card"
                          sx={{
                            width: 150,
                            height: 100,
                            objectFit: "cover",
                            borderRadius: 1,
                            border: "1px solid #ddd",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(manager.panCardUrl, "_blank")}
                        />
                      </Box>
                    )}
                     {manager?.panCardBackUrl && (
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" gutterBottom>
                          PAN Card Back
                        </Typography>
                        <Box
                          component="img"
                          src={manager.panCardBackUrl}
                          alt="PAN Card Back"
                          sx={{
                            width: 150,
                            height: 100,
                            objectFit: "cover",
                            borderRadius: 1,
                            border: "1px solid #ddd",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(manager.panCardBackUrl, "_blank")}
                        />
                      </Box>
                    )}

                    {/* Aadhaar Front */}
                    {manager?.aadhaarCardUrl?.[0] && (
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" gutterBottom>
                          Aadhaar Front
                        </Typography>
                        <Box
                          component="img"
                          src={manager.aadhaarCardUrl[0]}
                          alt="Aadhaar Front"
                          sx={{
                            width: 150,
                            height: 100,
                            objectFit: "cover",
                            borderRadius: 1,
                            border: "1px solid #ddd",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(manager.aadhaarCardUrl[0], "_blank")}
                        />
                      </Box>
                    )}

                    {/* Aadhaar Back */}
                    {manager?.aadhaarCardUrl?.[1] && (
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" gutterBottom>
                          Aadhaar Back
                        </Typography>
                        <Box
                          component="img"
                          src={manager.aadhaarCardUrl[1]}
                          alt="Aadhaar Back"
                          sx={{
                            width: 150,
                            height: 100,
                            objectFit: "cover",
                            borderRadius: 1,
                            border: "1px solid #ddd",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(manager.aadhaarCardUrl[1], "_blank")}
                        />
                      </Box>
                    )}

                    {/* Signature */}
                    {manager?.signatureUrl && (
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" gutterBottom>
                          Digital Signature
                        </Typography>
                        <Box
                          component="img"
                          src={manager.signatureUrl}
                          alt="Signature"
                          sx={{
                            width: 150,
                            height: 100,
                            objectFit: "contain",
                            borderRadius: 1,
                            border: "1px solid #ddd",
                            bgcolor: "#fff",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(manager.signatureUrl, "_blank")}
                        />
                      </Box>
                    )}

                    {/* Profile Photo */}
                    {manager?.userProfilePic && (
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" gutterBottom>
                          Profile Photo
                        </Typography>
                        <Box
                          component="img"
                          src={manager.userProfilePic}
                          alt="Profile"
                          sx={{
                            width: 100,
                            height: 100,
                            objectFit: "cover",
                            borderRadius: "50%",
                            border: "1px solid #ddd",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(manager.userProfilePic, "_blank")}
                        />
                      </Box>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            {/* Download Registration Certificate */}
            {manager?.registrationPdfUrl && (
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  startIcon={<Download />}
                  onClick={() => window.open(manager.registrationPdfUrl, "_blank")}
                >
                  Download Registration PDF
                </Button>
              </Grid>
            )}

            {/* Generate Invoice Button */}
            {manager?.registrationPaidAt && (
              <Grid item xs={12}>
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                  <GenerateInvoiceButton userId={manager?.userId} name={manager?.name} />
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        <div className="font-semibold flex items-start justify-between pr-11">
          <Table sx={{ width: "500px" }} border={2} className="border-2">
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>manager Name-</TableCell>
              <TableCell>{manager?.name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Mobile Number-</TableCell>
              <TableCell>{manager?.mobileNumber}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>PinCode-</TableCell>
              <TableCell>{manager?.servingPinCodes?.join(',')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Status-</TableCell>
              <TableCell>{manager?.status}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>City-</TableCell>
              <TableCell>{manager?.city}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Address-</TableCell>
              <TableCell>{manager?.fullAddress}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Joined At-</TableCell>
              <TableCell>
                {moment(manager?.createdAt).format("DD-MM-YYYY")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>
                Aadhar Card Number
              </TableCell>
              <TableCell>{manager?.aadhaarCardNumber}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Pan Number</TableCell>
              <TableCell>{manager?.panNumber}</TableCell>
            </TableRow>
          </Table>

          {/* Edit manager Button */}
          <div className="flex flex-col gap-4">

          
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleEditOpen}
          >
            Edit manager
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{ mt: 2 }}
            onClick={handleDeletePartner}
          >
            Delete manager
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{ mt: 2 }}
            onClick={handleDeletePartnerPermanent}
          >
            Permanent Delete
          </Button>
          </div>
        </div>
      </CustomTabPanel>

      {/* Edit manager Modal */}
      <Dialog open={openEdit} onClose={handleEditClose}>
        <DialogTitle>Edit manager</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            name="name"
            label="manager Name"
            value={formData.name || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="mobileNumber"
            label="Mobile Number"
            value={formData.mobileNumber || ""}
            onChange={handleChangeInput}
          />
          <TextField
            fullWidth
            margin="dense"
            name="city"
            label="City"
            value={formData.city || ""}
            onChange={handleChangeInput}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              name="status"
              value={formData.status || ""}
              onChange={handleChangeInput}
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="verified">Approved</MenuItem>
              <MenuItem value="unverified">Rejected Due to Verification</MenuItem>
              <MenuItem value="rejected">Rejected Due to Other</MenuItem>
            </Select>
          </FormControl>
           <Autocomplete
                      multiple
                      freeSolo
                      options={[]}
                      value={formData.servingPinCodes}
                      onChange={(e, newValue) => {
                        const validPincodes = newValue
                          .map((p) => p.trim())
                          .filter(
                            (p, index, self) =>
                              /^\d{1,6}$/.test(p) && self.indexOf(p) === index
                          );
                       setFormData({
                        ...formData,
                        servingPinCodes:validPincodes
                       })
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Pincodes"
                          placeholder="Enter up to 6-digit pincodes"
                          helperText="Only numeric values allowed (max 6 digits each)"
                        />
                      )}
                    />
          {/* <TextField
            fullWidth
            margin="dense"
            name="pincode"
            label="Pin Code"
            value={formData.pincode || ""}
            onChange={handleChangeInput}
          /> */}
          <TextField
            fullWidth
            margin="dense"
            name="fullAddress"
            label="Address"
            value={formData.fullAddress || ""}
            onChange={handleChangeInput}
          />
            <FormControl fullWidth margin="dense">
                      <InputLabel id="status-label">Registration Payment Status</InputLabel>
                      <Select
                        labelId="status-label"
                        name="isPaymentDone"
                        value={formData.isPaymentDone || ""}
                        onChange={handleChangeInput}
                      >
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="verified">Paid</MenuItem>
                      
                      </Select>
                    </FormControl>
                    {formData.isPaymentDone === 'verified' && (
                      <TextField
                        fullWidth
                        margin="dense"
                        name="paymentTransactionId"
                        label="Transaction ID"
                        value={formData.paymentTransactionId || ""}
                        onChange={handleChangeInput}
                        placeholder="Enter payment transaction ID"
                      />
                    )}
                    {formData.isPaymentDone === 'verified' && (
                      <TextField
                        fullWidth
                        margin="dense"
                        name="registrationPaidAt"
                        label="Payment Date & Time"
                        type="datetime-local"
                        value={
                          formData.registrationPaidAt
                            ? new Date(formData.registrationPaidAt).toISOString().slice(0, 16)
                            : ""
                        }
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            registrationPaidAt: e.target.value ? new Date(e.target.value) : null,
                          }))
                        }
                        InputLabelProps={{ shrink: true }}
                        helperText="Set the exact payment date and time"
                      />
                    )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose}>Cancel</Button>
          <Button onClick={handleUpdate} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MangerProfile;
